const selectors = {
  squeezeBoxTrigger: '.squeeze-box__item__trigger',
}

const squeezeBoxTriggers = document.querySelectorAll(
  selectors.squeezeBoxTrigger
)

squeezeBoxTriggers.forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    const content = this.nextElementSibling

    if (content.clientHeight) {
      this.classList.remove('is-open')
      content.style.maxHeight = 0
    } else {
      this.classList.add('is-open')
      content.style.maxHeight = content.scrollHeight + 'px'
    }
  })
})
